export default __webpack_public_path__ + "static/media/OPX.16b51144.svg";